// Polyfill for Object.fromEntries.
// At time of writing 8/3/2021 Object.entries was erroring out frequently so i'm using a polyfill
export const fromEntries = source =>
  Object.assign({}, ...Array.from(source, ([k, v]) => ({ [k]: v })));
